export default function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-50 dark:bg-gray-900 -mt-24">
      <div className="text-center">
        <div className="relative w-12 h-12 mx-auto mb-4">
          <div className="absolute w-12 h-12 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
          <div className="absolute w-12 h-12 border-4 border-transparent border-t-purple-500 dark:border-t-purple-400 rounded-full animate-spin"></div>
        </div>

        <p className="text-gray-700 dark:text-gray-300 text-base font-medium">
          Loading project
        </p>
      </div>
    </div>
  );
}
